import type { Company } from '~/types/types'

/**
 * Companies the current (authenticated) user belongs to, via the GraphQL API
 * (was: supabase RPC select_companies_of_user). Auth is now Better Auth.
 */
export default async function useCompaniesOfUser(): Promise<Company[]> {
    const { user } = useAuthUser()

    if (!user.value) {
        throw new Error("User must be authenticated to use this function")
    }

    const { companiesOfUser } = await GqlCompaniesOfUser({ userId: user.value.id })

    return (companiesOfUser ?? []) as unknown as Company[]
}
